(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drinkero-journal-article"]) return;
  try {
    
  function initDrinkeroJournal(scope) {
    scope.querySelectorAll('[data-dj-article]').forEach((root) => {
      if (root.dataset.djReady) return;
      root.dataset.djReady = 'true';
      const body = root.querySelector('[data-dj-body]');
      const toc = root.querySelector('[data-dj-toc]');
      const list = root.querySelector('[data-dj-toc-list]');
      const headings = [...body.querySelectorAll('h2')].filter((heading) => !heading.closest('.tptb-product-card-container'));
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'journal-heading-' + index;
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        li.append(link);
        list.append(li);
      });
      if (headings.length > 1) {
        toc.hidden = false;
        body.querySelectorAll('.type_table_of_contents').forEach((existing) => { existing.hidden = true; });
      }
      body.querySelectorAll('table').forEach((table) => {
        const wrap = document.createElement('div');
        wrap.className = 'dj-table-scroll';
        wrap.tabIndex = 0;
        table.before(wrap);
        wrap.append(table);
      });
    });
  }
  initDrinkeroJournal(document);
  document.addEventListener('shopify:section:load', (event) => initDrinkeroJournal(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
